import { QRCodeSVG } from "qrcode.react";
import Barcode from "react-barcode";
import { Link } from "react-router-dom";

export const DisplayCode = ({
  displayMode,
  value,
  handlePrint,
  ignorePrint,
}) => {
  const displayCode = () => {
    return displayMode === "QR" ? (
      <QRCodeSVG value={value} />
    ) : (
      <Barcode value={value} />
    );
  };
  return (
    <div className="col-md-5">
      {displayCode()}
      <h3 className="mt-5">Κωδικός επαλήθευσης</h3>
      <p>{value}</p>
      <h3>Κατάσταση</h3>
      <p>Το έγγραφο εκδόθηκε</p>
      {/* <h3>Ημερομηνία έκδοσης εισιτηρίου gov.gr</h3>
      <p>12/03/2023 22:42:30</p> */}
      {!ignorePrint ? (
        <>
          <button
            type="button"
            onClick={handlePrint}
            className="btn btn-primary btn-lg btn-login mb-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              viewBox="0 0 512 512"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
            </svg>
            <span>Εκτύπωση</span>
          </button>
          <div className="row">
            <div className="col">
              <Link
                to="/ticket-office/choose-user"
                className="btn btn-primary btn-lg"
              >
                Προσθήκη νέου εισιτηρίου
              </Link>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};
